import {
    SEND_OTP,
    SEND_OTP_SUCCESS,
    SEND_OTP_FAILURE,
    VerifyOTP_SETPSWD,
    VerifyOTP_SETPSWD_SUCCESS,
    VerifyOTP_SETPSWD_FAILURE,
    VERIFYOTP_NEWUSER,
    VERIFYOTP_NEWUSER_SUCCESS,
    VERIFYOTP_NEWUSER_FAILURE
} from './NewUserAction';
        const defaultState= {
        isLoading: false,
        otp: null,
        error: null,
        loginDetails: null,
        mobileNumber: null,
        role: null,
        usercode: null,
    }
    const NewUserReducer = (state = defaultState,action) => {
        switch(action.type) {
            case SEND_OTP:
                return { ...state, isLoading: true };
            case SEND_OTP_SUCCESS:
                return {otp: action.payload,isLoading: false};
            case SEND_OTP_FAILURE:
                return {...state,error:action.payload,isLoading: false};
            case VerifyOTP_SETPSWD:
                return { ...state, isLoading: true };
            case VerifyOTP_SETPSWD_SUCCESS:
                return {...state,loginDetails:action.payload.response,
                    role: action.payload.role,usercode:action.payload.usercode,
                    mobileNumber: action.payload.mobileno,
                    isLoading: false};
            case VerifyOTP_SETPSWD_FAILURE:
                return {...state,isLoading: false,error:action.payload.error};
            case VERIFYOTP_NEWUSER:
                return { ...state, isLoading: true };
            case VERIFYOTP_NEWUSER_SUCCESS:
                return {...state,isLoading: false};
            case VERIFYOTP_NEWUSER_FAILURE:
                return {...state,isLoading: false};
            default:
                return state;
        }
    }
    export default NewUserReducer;
